"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceInsightResponseToJSON = exports.AudienceInsightResponseFromJSONTyped = exports.AudienceInsightResponseFromJSON = exports.instanceOfAudienceInsightResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceInsightReportRow_1 = require("./AudienceInsightReportRow");
var EntityDimensionType_1 = require("./EntityDimensionType");
var InsightDimensionType_1 = require("./InsightDimensionType");
/**
 * Check if a given object implements the AudienceInsightResponse interface.
 */
function instanceOfAudienceInsightResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceInsightResponse = instanceOfAudienceInsightResponse;
function AudienceInsightResponseFromJSON(json) {
    return AudienceInsightResponseFromJSONTyped(json, false);
}
exports.AudienceInsightResponseFromJSON = AudienceInsightResponseFromJSON;
function AudienceInsightResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'granularity': !(0, runtime_1.exists)(json, 'granularity') ? undefined : json['granularity'],
        'entity': !(0, runtime_1.exists)(json, 'entity') ? undefined : (0, EntityDimensionType_1.EntityDimensionTypeFromJSON)(json['entity']),
        'insight': !(0, runtime_1.exists)(json, 'insight') ? undefined : (0, InsightDimensionType_1.InsightDimensionTypeFromJSON)(json['insight']),
        'rows': !(0, runtime_1.exists)(json, 'rows') ? undefined : (json['rows'].map(AudienceInsightReportRow_1.AudienceInsightReportRowFromJSON)),
    };
}
exports.AudienceInsightResponseFromJSONTyped = AudienceInsightResponseFromJSONTyped;
function AudienceInsightResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'granularity': value.granularity,
        'entity': (0, EntityDimensionType_1.EntityDimensionTypeToJSON)(value.entity),
        'insight': (0, InsightDimensionType_1.InsightDimensionTypeToJSON)(value.insight),
        'rows': value.rows === undefined ? undefined : (value.rows.map(AudienceInsightReportRow_1.AudienceInsightReportRowToJSON)),
    };
}
exports.AudienceInsightResponseToJSON = AudienceInsightResponseToJSON;
